/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import { withTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

import { Grid, Typography } from '@material-ui/core';

import SendIcon from '@material-ui/icons/Send';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';

import { useMutation } from '@apollo/client';
import { CREATE_MESSAGE } from '../../queries';
import { useThemeData } from '../../context/ThemeDataContext';

import { yupResolver } from '@hookform/resolvers/yup';
import { ContactSchema } from '../../validations/UserValidation';
import { formContent } from '../../statics/ContactFormData';
import GeneralButton from '../Buttons';
import GeneralText from '../Fonts';

function ContactFormComponent(props) {
  const { site_id, site_name, emails } = useThemeData().themeData.site;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(ContactSchema),
  });

  const onCompleted = () => {
    props.setCompleted(true);
  };

  const [createMessage, { loading: loadingContactMessage, error: errorContactMessage }] =
    useMutation(CREATE_MESSAGE, {
      onCompleted: onCompleted,
    });

  const onSubmit = (e) => {
    createMessage({
      variables: {
        user_id: props.user_id,
        site_id: site_id,
        firstname_sender: e.firstname_sender,
        lastname_sender: e.lastname_sender,
        email_sender: e.email_sender,
        type: 'contact',
        subject: e.subject,
        message: e.message,
      },
    });
  };

  if (loadingContactMessage) return <p>{props.t('Loading...')}</p>;
  if (errorContactMessage) return <p>{props.t('Looks like we have a problem...')}</p>;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item className="col-lg-6 col-md-12">
        <Grid container>
          <GeneralText className="padding-left-1r" variant="h3" gutterBottom={true}>
            {props.t('contact:Contact')}
          </GeneralText>
        </Grid>

        <Grid container>
          <Grid item md={6} className="contact-text">
            <Typography>{site_name}</Typography>
            {/* gegegvens hebben we niet  */}
            {/*<Card.Text className="no-margin-bttm">mussenstraat 55</Card.Text>*/}
            {/*<Card.Text className="no-margin-bttm">1223 RB Hilversum</Card.Text>*/}
            {/*<Card.Text className="no-margin-bttm">035 - 20 33 013</Card.Text>*/}
            {emails[0].email && (
              <Typography className="no-margin-bttm">{emails[0].email}</Typography>
            )}
            {/*<Card.Text >KvK: 64700267</Card.Text>*/}
          </Grid>
          <Grid item md={6}></Grid>
        </Grid>

        {formContent.inputs.map((input, key) => (
          <Grid container key={key}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                {...register(input.name, {
                  shouldUnregister: true,
                })}
                id={input.id}
                type={input.type}
                label={props.t(`contact:${input.label}`)}
                autoComplete={input.autocomplete}
                multiline={input.multiline}
                minRows={input.rows}
                className="mb-2"
                variant="outlined"
                autoFocus
                fullWidth
              />

              {errors[input.name] && (
                <Alert severity="warning">
                  {props.t(`register:${errors[input.name].message}`)}
                </Alert>
              )}
            </Grid>
          </Grid>
        ))}

        <GeneralButton
          type="submit"
          name="submit"
          className="nav-button col-12 col-md-6 col-lg-6"
          style={{
            width: '12.5rem',
          }}
          endIcon={<SendIcon color="inherit" />}
        >
          {props.t('contact:Submit')}
        </GeneralButton>
      </Grid>
    </form>
  );
}

export default React.memo(withTranslation(['contact, register'])(ContactFormComponent));
